angular
	.module 'App.Directive'
	.directive 'gallery', ->
		scope:
			mainImage: '=?'
			mainImageName: '=?'
			images: '=?'
			allowEdit: '<?'
			settings: '=?'
		restrict: 'E'
		templateUrl: '@directive/gallery/gallery.view.html'
		controller: 'GalleryController'
		controllerAs: 'gallery'
		bindToController: true

class GalleryController extends AbstractController
	@register()
	@inject '$scope',
		'$uibModal'
		'Guid'
		'MessageTerminal'

	initialize: ->
		defaultSettings =
			active: 0
			interval: 0
			noWrap: false
			noTransition: false
			noPause: false
			# This parameter does not work and must be hard-coded to template as UibCarousel does not evaluate it's value
			# templateUrl: '@directive/gallery/gallery.carousel.view.html'

		@mainImageObject =
			is_main_image: true
			image: @mainImage
			name: @mainImageName
			order: 0
			index: 0

		@allowEdit ?= true
		@settings ?= {}
		@images ?= []
		@carouselSettings = angular.extend {}, defaultSettings, @settings

		@indexImages()

		@MessageTerminal.on @$scope, @MessageTerminal.events.GALLERY.EDIT_ORDER,
			=>
				@indexImages()
				# If switching to current image index then transition to other slides will not work - carousel bug
				@carouselSettings.active = 0

		@MessageTerminal.on @$scope, @MessageTerminal.events.GALLERY.AFTER_SAVE,
			=>
				for image in @images
					image.is_new = false
					image.is_changed = false

		@$scope.$watch 'gallery.mainImageObject.image', => @mainImage = @mainImageObject.image

	indexImages: ->
		@images.sort (a, b) => parseInt(a.order || 0) - parseInt(b.order || 0)

		for image, index in @images
			# +1 because at index 0 position there is main image
			image.index = index + 1

	deleteImage: (image) ->
		if !@allowEdit
			console.error 'Image deletion is disabled'

			return

		@carouselSettings.active = 0

		if image.is_main_image
			@mainImage = null
			@mainImageObject.image = null

			@MessageTerminal.publish @MessageTerminal.events.GALLERY.EDIT, @mainImageObject

			return

		@images = _.reject @images, {id: image.id}
		@indexImages()

		@MessageTerminal.publish @MessageTerminal.events.GALLERY.DELETE, image

	addImage: (autoEdit = true) ->
		if !@allowEdit
			console.error 'Image addition is disabled'

			return

		newIndex = if _.isEmpty(@images) then 1 else parseInt(_.max(@images, 'order').order) + 1

		newImage =
			id: @Guid.generate()
			image: null
			name: null
			index: newIndex
			order: newIndex
			is_main_image: false
			is_new: true

		@images.push newImage
		@indexImages()
		@carouselSettings.active = newImage.index

		@MessageTerminal.publish @MessageTerminal.events.GALLERY.EDIT, newImage

		if autoEdit
			@editImage newImage

	editImage: (image) ->
		@modalInstance = @$uibModal.open
			templateUrl: '@directive/gallery/modals/gallery.modal.view.html'
			controller: 'GalleryModalController'
			controllerAs: 'galleryModal'
			bindToController: true
			size: 'lg'
			resolve:
				image: => image
				mainImageName: => @mainImageName
				allowEdit: => @allowEdit
